export default __webpack_public_path__ + "static/media/laval3.1a81c877.jpg";